import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { GlobalVar } from '../globals/global-var';


//全局錯誤處理，需要再app.module啟用

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorErrorService {

  constructor(private globalVar: GlobalVar) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      //catchError((error: HttpErrorResponse) => {
      //  alert("攔截錯誤回應 " + error.status + " " + error.statusText + ":" + JSON.stringify(error.error));
      //  return of(null);
      //}),
      finalize(() => this.globalVar.progressBar = false)
    );
  }
}
